import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/AppShell";
import Vehicles from "@/pages/tabs/Vehicles";
import Clients from "@/pages/tabs/Clients";
import Trips from "@/pages/tabs/Trips";
import AcertoFinal from "@/pages/tabs/AcertoFinal";
import Fueling from "@/pages/tabs/Fueling";
import Suppliers from "@/pages/tabs/Suppliers";
import Expenses from "@/pages/tabs/Expenses";
import Maintenance from "@/pages/tabs/Maintenance";
import Analysis from "@/pages/tabs/Analysis";
import MyDriverDashboard from "@/pages/tabs/MyDriverDashboard";
import Reports from "@/pages/tabs/Reports";
import GPS from "@/pages/tabs/GPS";
import Chat from "@/pages/tabs/Chat";
import Profile from "@/pages/tabs/Profile";
import BaixarApp from "@/pages/tabs/BaixarApp";

export default function DriverDashboard() {
  return (
    <Routes>
      <Route element={<AppShell basePath="/motorista" />}>
        <Route index element={<Navigate to="fretes" replace />} />
        <Route path="veiculos" element={<Vehicles />} />
        <Route path="clientes" element={<Clients />} />
        <Route path="fretes" element={<Trips />} />
        <Route path="acerto" element={<AcertoFinal />} />
        <Route path="abastecimentos" element={<Fueling />} />
        <Route path="fornecedores" element={<Suppliers />} />
        <Route path="despesas" element={<Expenses />} />
        <Route path="manutencao" element={<Maintenance />} />
        <Route path="analise" element={<Analysis />} />
        <Route path="minha-area" element={<MyDriverDashboard />} />
        <Route path="relatorios" element={<Reports />} />
        <Route path="gps" element={<GPS />} />
        <Route path="chat" element={<Chat />} />
        <Route path="perfil" element={<Profile />} />
        <Route path="baixar-app" element={<BaixarApp />} />
      </Route>
    </Routes>
  );
}
